import {Box, FormLabel, Typography} from '@mui/material'
import {FC, ReactNode, useRef} from 'react'
import {makeStyles} from 'tss-react/mui'

const SubtitledInput: FC<SubtitledInputProps> = ({
  children, className, isEmptyValidationErrorMessageHidden = false, subtitle, title,
}) => {
  const containerRef = useRef<HTMLDivElement>()
  const {classes: styles} = useStyles({})
  if (isEmptyValidationErrorMessageHidden) {
    Array.from(containerRef.current?.querySelectorAll('span') ?? []).filter(
      // Select span having the text "&ZeroWithSpace;".
      span => span.textContent === '\u200B'
    ).map(el => el.setAttribute('class', styles.isEmptyValidationErrorMessageHidden))
  }
  return (
    <Box ref={containerRef} className={`${styles.root} ${className ?? ''}`}>
      <FormLabel><Typography>{title}</Typography></FormLabel>
      <Typography color="textSecondary" variant="caption">{subtitle}</Typography>
      {children}
    </Box>
  )
}

const useStyles = makeStyles<any>()(() => ({
  hideValidationMessage: {
    display: 'none',
  },
  isEmptyValidationErrorMessageHidden: {
    display: 'none',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}))

interface SubtitledInputProps {
  className?: string
  children: ReactNode
  isEmptyValidationErrorMessageHidden?: boolean
  title: string | ReactNode
  subtitle?: string | ReactNode
}

export default SubtitledInput
